'use client';

import { cn } from '@/lib/utils';

import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import { InputDropdownProps } from '@/components/atoms/InputDropdown';
import { InputDropdownWithImage } from '@/components/atoms/InputDropdownWithImage';
import { Text } from '@/components/atoms/Text';
import { useTranslation } from '@/lib/i18n/i18n.client';

export type Option = {
  value: string;
  type: string;
  label: string;
  icon: ImageStrapiProps;
  [key: string]: any;
};

interface ProductDropdownProps
  extends Omit<
    InputDropdownProps<Option>,
    'options' | 'renderOption' | 'renderSelectedValue' | 'value'
  > {
  options: Option[];
  value: Option | null;
  onOptionChange: (option?: Option) => void;
  isDisabled?: boolean;
}

export const ProductDropdown = ({
  options,
  value,
  onOptionChange,
  isDisabled,
  classNames,
  ...props
}: ProductDropdownProps) => {
  const { texts } = useTranslation();
  return (
    <InputDropdownWithImage
      isDisabled={isDisabled}
      {...props}
      value={value ? value.value : undefined}
      classNames={{
        ...classNames,
        inputField: {
          ...classNames?.inputField,
          root: cn('text-body-m', classNames?.inputField?.root),
        },

        root: cn('w-full m:pl-9', classNames?.root),
      }}
      placeholder={texts.comparison_table.select_product_placeholder}
      popoverProps={{
        classNames: {
          childrenWrapper: 'w-full shadow-card',
        },
        contentProps: {
          avoidCollisions: true,
        },
      }}
      leftIcon={
        value?.icon ? (
          <ImageStrapi
            block={value.icon}
            inner={{ classNames: { image: '' } }}
          />
        ) : null
      }
      options={options}
      onOptionChange={(val) => {
        const selectedOption = options.find((o) => o.value === val);
        onOptionChange(selectedOption);
      }}
      renderOption={({ option }) => (
        <div className='items-center gap-x-2.5'>
          <Text variant='body-s' classNames={{ wrapper: 'text-gray-500' }}>
            {option.type}
          </Text>
          <Text variant='body-m' classNames={{ wrapper: 'font-medium' }}>
            {option.label}
          </Text>
        </div>
      )}
      renderSelectedValue={({ option }) => (
        <div className=''>
          <Text variant='body-s' classNames={{ wrapper: 'text-gray-500' }}>
            {option.type}
          </Text>

          <Text variant='body-m' classNames={{ wrapper: 'font-medium' }}>
            {option.label}
          </Text>
        </div>
      )}
    />
  );
};
